import {  ChangeDetectorRef         ,
          Component                 ,
          inject                    ,
          OnInit                    } from '@angular/core';
import {  FormArray                 ,
          FormControl               ,
          ReactiveFormsModule       } from '@angular/forms';
import {  CommonModule              } from '@angular/common';
import {  ActivatedRoute            } from '@angular/router';
import {  distinctUntilChanged      ,
          lastValueFrom             ,
          map                       ,
          switchMap                 ,
          tap                       } from 'rxjs';

import {  DropdownModule            } from 'primeng/dropdown';

import {  StateCollectionService    } from 'app/@shared/collections/state.collection.service';
import {  UtilityCollectionService  } from 'app/@shared/collections/utility.collection.service';
import {  GlobalRedirectService     } from 'app/@routes/redirect.service';
import {  CcFormArray, CcFormGroup  } from 'app/@shared/forms/form-group/cc-form-group.extention';
import {  FormUtil                  } from 'nv@services/form-util.service';
import {  TranslatePipe             } from 'nv@services/translate.service';
import {  WizzardSiteDetails        } from 'nv@features/sites/@components/wizzard-site-details/wizzard-site-details.component';
import {  SidebarManageReports      } from 'nv@features/@modals/manage-reports/manage-reports.component';
import {  SiteApi                   } from 'nv@api/site.api.service';
import {  ReportApi                 } from 'nv@api/report.api.service';
import {  ReportModel               } from 'nv@models/report.model';

import {  WizzardSiteConfig         } from '../@components/wizzard-site-config/wizzard-site-config.component';
import {  TemplateElectricityPrice  } from '../@templates/template-electricity-price/template-electricity-price.component';
import {  TemplatePricingDetails    } from '../@templates/template-pricing-details/template-pricing-details.component';
import {  TemplateRoi               } from '../@templates/template-roi/template-roi.component';
import {  TemplateSiteLocation      } from '../@templates/template-site-location/template-site-location.component';
import {  TemplateUtilityService    } from '../@templates/template-utility-service/template-utility-service.component';
import {  SiteState                 } from './site.state';
import {  SiteService               } from './site.service';
import {  SiteResolverModel         } from '../site.resolver';
import {  TemplatePortNumber        } from '../@templates/template-port-number/template-port-number.component';
import { RoiApi } from 'nv@api/roi.api.service';
import { TemplateDemand } from "../@templates/template-demand/template-demand.component";
import { TemplateCostOperation } from '../@templates/template-cost-operation/template-cost-operation.component';
import { TemplateCostOperationMini } from '../@templates/template-cost-operation-mini/template-cost-operation-mini.component';
import { TemplateCapitalExpense } from '../@templates/template-capital-expense/template-capital-expense.component';
import { WizzardSiteExtended } from '../@components/wizzard-site-extended/wizzard-site-extended.component';
import { TemplateRoiReport } from "../@templates/template-roi-report/template-roi-report.component";

@Component({
  selector    : 'page-site',
  templateUrl : './site.component.html',
  styleUrl    : './site.component.scss',
  providers   : [SiteState, SiteService],
  imports: [
    ReactiveFormsModule,
    DropdownModule,
    WizzardSiteDetails,
    WizzardSiteConfig,
    WizzardSiteExtended,
    CommonModule,
    SidebarManageReports,
    TranslatePipe,
    TemplateSiteLocation,
    TemplatePortNumber,
    TemplateUtilityService,
    TemplateElectricityPrice,
    TemplatePricingDetails,
    TemplateRoi,
    TemplateDemand,
    TemplateCostOperation,
    TemplateCostOperationMini,
    TemplateCapitalExpense,
    TemplateRoiReport
],
})
export class SitePage implements OnInit {

  public globalRedirect             = inject(GlobalRedirectService);
  public $stateCollectionService    = inject(StateCollectionService);
  public $utilityCollectionService  = inject(UtilityCollectionService);
  public $$ui                       = inject(SiteState);
  public fu                         = inject(FormUtil);

  private $roiApiService            = inject(RoiApi);
  private SiteService               = inject(SiteService);
  private $siteApiService           = inject(SiteApi);
  private $reportApi                = inject(ReportApi);
  private route                     = inject(ActivatedRoute);
  private cdref                     = inject(ChangeDetectorRef);

  public $formArrayMap: any;
  public wizzardIndex = 1;
  public mapParameters: any = null;

  public siteResolver!: SiteResolverModel;
  public projectId!: string | null;

  public reportCollection: any;

  public $form = new CcFormGroup({
    roiPeriod                   : new FormControl<number  | null>(null  , []),
    roiAvgWeeklyVisits          : new FormControl<number  | null>(null  , []),
    avgHandledWeeklyVisits      : new FormControl<number  | null>(null  , []),
    trafficThirtyMiles          : new FormControl<number  | null>(null  , []),
    trafficSeventyMiles         : new FormControl<number  | null>(null  , []),
    trafficAboveSeventy         : new FormControl<number  | null>(null  , []),
    roiNpv                      : new FormControl<number  | null>(null  , []),
    roiWeeklyEnergyConsumption  : new FormControl<number  | null>(null  , []),
    roiIsScored                 : new FormControl<boolean | null>(false , []),

    //
    roiProfit                   : new FormControl<number  | null>(null  , []),
    roiRevenue                  : new FormControl<number  | null>(null  , []),


    costFixed                   : new FormControl<number  | null>(null  , []),
    costEnergy                  : new FormControl<number  | null>(null  , []),
    costDemand                  : new FormControl<number  | null>(null  , []),
    operatingExpense            : new FormControl<number  | null>(null  , []),
    opex                        : new FormControl<number  | null>(null  , []),

    //
    suggestedNumberOfPorts      : new FormControl<number  | null>(null  , []),
    totalCost                   : new FormControl<number  | null>(null      ),
    totalPopulation             : new FormControl<number  | null>(null      ),
    onNeviRoute                 : new FormControl<number  | null>(null      ),
    incomeAndReturnPerYear      : new FormControl<number  | null>(null      ),
    scatterGraphPerHour         : new FormControl<number  | null>(null      ),
    predictedEvRegistrations    : new FormControl<number  | null>(null      ),
    yearlyAverageRate           : new FormControl<number  | null>(null      ),
    yearlyDemandCost            : new FormControl<number  | null>(null      ),
    estimatedDemandCost         : new FormControl<number | null>(null),
    
    score                                 : new FormControl<number | null>(null),
    marketPotentialScore                  : new FormControl<number | null>(null),
    chargingInfrastructureScore           : new FormControl<number | null>(null),
    financialUtilizationPerformanceScore  : new FormControl<number | null>(null),
    neviScore                             : new FormControl<number | null>(null),
    
    competition                           : new FormControl<any>(null),
    withNodes                             : new FormControl<any>(null),
  });

  public $parentForm = new CcFormGroup({
    steps: new CcFormArray([this.$form]),
  });


  public ngOnInit(): void {

    this.siteResolver = this.route.snapshot.data['data'];

    this.$parentForm.get('steps')?.valueChanges.pipe(
        map((collection: any[]) => collection.reduce(
            (acc, formCollection) => ({ ...acc, ...formCollection }), {}
          )
        ),
        tap((formArrayMap) => {
          this.$formArrayMap = formArrayMap;
        }),
        distinctUntilChanged(),
        switchMap(() => this.SiteService.sub$)
      )
      .subscribe(async (key) => {

        if (key == 'init@GEOCODE') {
          this.SiteService.$serviceGetGeocodeData(this.$formArrayMap);
        }

        if (key == 'init@UTILITY') {

          this.SiteService.$serviceGetUtilityCollection(this.$formArrayMap);
          this.processOnSiteLocationCalculated();
        }

        if (key == 'select_utility') {
          this.SiteService.$serviceGetUtilityPlan(this.$formArrayMap);
        }

        if( key == 'select_utility_plan') {

          this.$roiApiService.getDemandAverage({ "utilityId": this.$formArrayMap.utilityPlanId }).subscribe((result: any) => {
              this.$form.get('yearlyAverageRate'   )?.setValue(result.yearlyAverageRate);
          });
        }

      });
  }

  /**
   * @author Mihail Petrov
   * @returns
   */
  public getFormArray() {
    return this.$parentForm.get('steps') as FormArray;
  }

  /**
   *
   */
  public async ngAfterViewInit() {

    if (!this.siteResolver.siteModel) return;

    this.fu.trackAndUpdateControls(this.getFormArray(), this.siteResolver.siteModel.data);
    this.cdref.detectChanges();

    this.SiteService.sendFormData('process@HardwareConfig', this.siteResolver?.siteModel?.data?.hardwareConfigCollection);

    await this.SiteService.$serviceGetGeocodeData(this.$formArrayMap);
    await this.SiteService.$serviceGetUtilityCollection(this.$formArrayMap);
    await this.SiteService.$serviceGetUtilityPlan(this.$formArrayMap);

    this.SiteService.sendFormData('process@DATE'          , this.$formArrayMap.anticipatedStartDate);
    this.SiteService.sendFormData('selectUtilityGroup'    , this.$formArrayMap);
    this.SiteService.sendFormData('process@DRIVER_PRICE'  , this.$formArrayMap.driverPriceMultiplier);

    this.$$ui.state.isUtilityDetailsPreviewVisible = true;
    this.$$ui.state.isPricingDetailsPreviewVisible = true;

    if (this.siteResolver.siteModel.data.roiIsScored) {

      this.$$ui.state.isRoiPreviewVisible           = true;
      this.$$ui.state.isReportAvailable             = true;
      this.$$ui.state.isCostOperationPreviewVisible = true;
    }
  }

  /**
   * @author Mihail Petrov
   * @param stepId
   */
  public processStep(stepId: number) {

    if (stepId < this.wizzardIndex) {
      this.wizzardIndex = stepId;
      return;
    }

    (this.getFormArray().at(this.wizzardIndex) as CcFormGroup)?.markFormGroupDirty().isFormValid(() => {
        this.wizzardIndex = stepId;
      });
  }

  /**
   * @author Mihail Petrov
   */
  public processNext() {

    (this.getFormArray().at(this.wizzardIndex) as CcFormGroup)?.markFormGroupDirty().isFormValid(() => {
        if (this.wizzardIndex == 2) this.processScore();
        if (this.wizzardIndex == 1) this.wizzardIndex++;
      });
  }

  /**
   * @author Mihail Petrov
   */
  public processPrev() {
    this.wizzardIndex--;
  }

  /**
   * @author Mihail Petrov
   */
  public async processScore(withNodes = true) {
    this.finalizeDriverPriceMultiplier();

    this.$form.get('withNodes'        )?.setValue(withNodes          );
    
    const projectSummary: any = await lastValueFrom(this.SiteService.$scoreSite(this.$formArrayMap));

    console.log(projectSummary)

    this.$form.get('roiPeriod'                  )?.setValue(projectSummary.roiInMonths                  );
    this.$form.get('roiAvgWeeklyVisits'         )?.setValue(projectSummary.avgWeeklyVisits              );
    this.$form.get('avgHandledWeeklyVisits'     )?.setValue(projectSummary.avgHandledWeeklyVisits       );
    this.$form.get('trafficThirtyMiles'         )?.setValue(projectSummary.trafficThirtyMiles           );
    this.$form.get('trafficSeventyMiles'        )?.setValue(projectSummary.trafficSeventyMiles          );
    this.$form.get('trafficAboveSeventy'        )?.setValue(projectSummary.trafficAboveSeventy          );
    this.$form.get('roiNpv'                     )?.setValue(projectSummary.npv                          );
    this.$form.get('roiProfit'                  )?.setValue(projectSummary.profit                       );
    this.$form.get('roiRevenue'                 )?.setValue(projectSummary.revenue                      );

    this.$form.get('costFixed'                  )?.setValue(projectSummary.costFixed                    );
    this.$form.get('costEnergy'                 )?.setValue(projectSummary.costEnergy                   );
    this.$form.get('costDemand'                 )?.setValue(projectSummary.costDemand                   );
    this.$form.get('operatingExpense'           )?.setValue(projectSummary.operatingExpense             );
    this.$form.get('opex'                       )?.setValue(projectSummary.opex                         );

    this.$form.get('roiMonthlyEnergyConsumption')?.setValue(projectSummary.monthlyEnergyConsumptionKwh  );
    this.$form.get('roiWeeklyEnergyConsumption' )?.setValue(projectSummary.weeklyEnergyConsumptionKwh   );
    this.$form.get('suggestedNumberOfPorts'     )?.setValue(projectSummary.suggestedNumberOfPorts       );
    this.$form.get('roiIsScored'                )?.setValue(true);
    this.$form.get('totalPopulation'            )?.setValue(projectSummary.totalPopulation              );
    this.$form.get('onNeviRoute'                )?.setValue(projectSummary.isOnNeviRoute                );
    this.$form.get('incomeAndReturnPerYear'     )?.setValue(projectSummary.incomeAndReturnPerYear       );
    this.$form.get('scatterGraphPerHour'        )?.setValue(projectSummary.scatterGraphPerHour          );
    this.$form.get('predictedEvRegistrations'   )?.setValue(projectSummary.predictedEvRegistrations     );
    this.$form.get('yearlyDemandCost'           )?.setValue(projectSummary.yearlyDemandCost             );
    this.$form.get('estimatedDemandCost')?.setValue(projectSummary.estimatedDemandCost);
    
    this.$form.get('score'                                        )?.setValue(projectSummary.score          );
    this.$form.get('marketPotentialScore'                         )?.setValue(projectSummary.marketPotentialScore          );
    this.$form.get('chargingInfrastructureScore'                  )?.setValue(projectSummary.chargingInfrastructureScore          );
    this.$form.get('financialUtilizationPerformanceScore'         )?.setValue(projectSummary.financialUtilizationPerformanceScore          );
    this.$form.get('neviScore'                                    )?.setValue(projectSummary.neviScore          );

    this.$$ui.state.isRoiPreviewVisible           = true;
    this.$$ui.state.isCostOperationPreviewVisible = true;

    await this.processSave();

    this.$$ui.state.isReportAvailable = true;
    this.wizzardIndex++;
  }

  /**
   * @author Mihail Petrov
   */
  public processSaveAction() {

    (this.getFormArray().at(this.wizzardIndex) as CcFormGroup)?.markFormGroupDirty().isFormValid(async () => {
        await this.processSave();
    });
  }

  /**
   * @author Mihail Petrov
   */
  public async processSave() {

    this.finalizeDriverPriceMultiplier();

    if (this.siteResolver.siteModel) {
      const siteId = this.siteResolver.siteModel.id as string;

      await lastValueFrom(this.$siteApiService.updateSite({
          id        : this.siteResolver.siteModel.id as string,
          projectId : this.siteResolver.projectId,
          name      : this.$formArrayMap.name,
          data      : this.$formArrayMap,
        })
      );

      const updatedSiteResponse = await lastValueFrom(
        this.$siteApiService.getSite(siteId)
      );

      this.siteResolver.siteModel = updatedSiteResponse.data;

      this.$form.get('score'                                        )?.setValue(updatedSiteResponse.data.data.score          );
      this.$form.get('marketPotentialScore'                         )?.setValue(updatedSiteResponse.data.data.marketPotentialScore          );
      this.$form.get('chargingInfrastructureScore'                  )?.setValue(updatedSiteResponse.data.data.chargingInfrastructureScore          );
      this.$form.get('financialUtilizationPerformanceScore'         )?.setValue(updatedSiteResponse.data.data.financialUtilizationPerformanceScore          );
      this.$form.get('neviScore'                                    )?.setValue(updatedSiteResponse.data.data.neviScore          );
      this.$form.get('competition'                                    )?.setValue(updatedSiteResponse.data.data.competition          );

      return this.siteResolver.siteModel;
    }

    const response = await lastValueFrom(this.$siteApiService.createNewSite({
        projectId   : this.siteResolver.projectId,
        name        : this.$formArrayMap.name,
        data        : this.$formArrayMap,
      })
    );

    const updatedSiteResponse = await lastValueFrom(
      this.$siteApiService.getSite(response.data.id)
    );

    this.siteResolver.siteModel = updatedSiteResponse.data;

    this.$form.get('score'                                        )?.setValue(updatedSiteResponse.data.data.score          );
    this.$form.get('marketPotentialScore'                         )?.setValue(updatedSiteResponse.data.data.marketPotentialScore          );
    this.$form.get('chargingInfrastructureScore'                  )?.setValue(updatedSiteResponse.data.data.chargingInfrastructureScore          );
    this.$form.get('financialUtilizationPerformanceScore'         )?.setValue(updatedSiteResponse.data.data.financialUtilizationPerformanceScore          );
    this.$form.get('neviScore')?.setValue(updatedSiteResponse.data.data.neviScore);
    this.$form.get('competition'                                    )?.setValue(updatedSiteResponse.data.data.competition          );

    this.globalRedirect.inContextOfApplication(false).viewSite(this.siteResolver.siteModel.id!);
    return this.siteResolver.siteModel;
  }

  /**
   * @author Mihail Petrov
   */
  public processOnSiteLocationCalculated() {
    this.$$ui.state.isSiteLocationPreviewVisible = true;
  }

  /**
   * @author Mihail Petrov
   */
  public processOnUtilityDetailsCalculated() {

    this.$$ui.state.isUtilityDetailsPreviewVisible  = true;
    this.$$ui.state.isDemandDetailsPreviewVisible   = true
  }

  /**
   * @author Mihail Petrov
   */
  public processOnPricingDetailsCalculated() {
    this.$$ui.state.isPricingDetailsPreviewVisible = true;
  }

  /**
   * @author Mihail Petrov
   */
  public async downloadReport() {

    const id                                      = this.siteResolver?.siteModel?.id as string;
    const reportCollection: any                   = (await lastValueFrom(this.$reportApi.getSiteReport(id)))?.data;

    this.$$ui.state.isSidebarManageReportsVisible = true;
    this.$$ui.data.sidebarTransactionObject       = reportCollection;
  }

  /**
   * @author Mihail Petrov
   * @param $event
   */
  public processDownloadReport($event: ReportModel) {
    window.open($event.url, '_blank');
  }

  /**
   *
   */
  public goBack() {
    this.globalRedirect.inContextOfApplication().viewProject(this.siteResolver.projectId);
  }

  private finalizeDriverPriceMultiplier(): void {
  // 1) Check which mode the user is in
  const hasDriverPriceMode = this.$formArrayMap?.hasDriverPriceMode; 
  // The plan type can be "fixed" or "tou"
  const planType           = this.$formArrayMap?.utilityPlanType;

  if (hasDriverPriceMode) {
    // ----------------------------
    // Option A: "driverPrice" is the source of truth
    // so recalc the multiplier from driverPrice
    // ----------------------------
    const typedValue = this.$formArrayMap.driverPrice ?? 0;
    if (typedValue <= 0) return;

    if (planType === 'fixed') {
      const electricityCost = this.$formArrayMap?.electricityCost ?? 0;
      if (electricityCost > 0) {
        const newMultiplier = parseFloat((typedValue / electricityCost).toFixed(2));
        this.$formArrayMap.driverPriceMultiplier = newMultiplier;
      }
    }
    else if (planType === 'tou') {
      // treat driverPrice as "peak"
      const electricityCostPeak = this.$formArrayMap?.electricityCostPeak ?? 0;
      if (electricityCostPeak > 0) {
        const newMultiplier = parseFloat((typedValue / electricityCostPeak).toFixed(2));
        this.$formArrayMap.driverPriceMultiplier = newMultiplier;
      }
    }
  } 
  else {
    // ----------------------------
    // Option B: "driverPriceMultiplier" is the source of truth
    // so recalc driverPrice from the multiplier
    // ----------------------------
    const multiplier = this.$formArrayMap?.driverPriceMultiplier ?? 1;

    if (planType === 'fixed') {
      const electricityCost = this.$formArrayMap?.electricityCost ?? 0;
      const newDriverPrice  = parseFloat((electricityCost * multiplier).toFixed(2));
      this.$formArrayMap.driverPrice = newDriverPrice;
      
      // If you have separate fields for peak/offpeak, you can clear them or leave them alone
      this.$formArrayMap.driverPricePeak       = null;
      this.$formArrayMap.driverPriceOffPeak    = null;
      this.$formArrayMap.driverPriceSuperOffPeak = null;
    }
    else if (planType === 'tou') {
      const costPeak      = this.$formArrayMap?.electricityCostPeak      ?? 0;
      const costOffPeak   = this.$formArrayMap?.electricityCostOffPeak   ?? 0;
      const costSuperOff  = this.$formArrayMap?.electricityCostSuperOffPeak ?? 0;

      const newPeak       = parseFloat((costPeak    * multiplier).toFixed(2));
      const newOffPeak    = parseFloat((costOffPeak * multiplier).toFixed(2));
      const newSuperOff   = parseFloat((costSuperOff * multiplier).toFixed(2));

      this.$formArrayMap.driverPricePeak        = newPeak;
      this.$formArrayMap.driverPriceOffPeak     = newOffPeak;
      this.$formArrayMap.driverPriceSuperOffPeak= newSuperOff;
      // driverPrice might be the same as peak or an average
      this.$formArrayMap.driverPrice            = newPeak;
    }
  }
}

}
